export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/account-icon.svg?c65a55ed065c4c7aeff32a310e999062";